import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { withTranslation } from '@wix/yoshi-flow-editor';

import { PaymentType } from '@wix/wix-vod-constants/api-types';
import EVENTS from '../../../constants/events';
import { getCurrentUserEmail } from '../../../selectors/current-site-user';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import focus from '@wix/wix-vod-shared/dist/esm/widget/utils/accessibility-focus';

import IconButton from '../../../components/buttons/icon/icon';
import AccountInfo from '../../../components/account/account-button/account-info/account-info';
import { AccountSubscription } from '../../../components/account/account-button/account-subscription/account-subscription';

import styles from './modal-account-info.scss';
import {
  getCompId,
  getSiteUrl,
  getInstance,
} from '../../../redux/hydrated-data/hydrated-data';
import { pubSubPublish } from '../../../worker/actions/pub-sub/publish';
import getQueryParams from '../../../utils/get-query-params';
import { logWidgetSystem } from '../../../worker/actions/bi';
import { cancelOrder } from '../../../redux/actions/payment';

const mapStateToProps = (state) => ({
  channelData: getChannelForWidget(state),
  currentSiteUserEmail: getCurrentUserEmail(state),
  compId: getCompId(state),
  siteUrl: getSiteUrl(state),
  instance: getInstance(state),
});

const mapDispatchToProps = {
  pubSubPublish,
  logWidgetSystem,
  cancelOrder,
};
class ModalAccountInfo extends React.Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    channelData: PropTypes.object.isRequired,
    currentSiteUserEmail: PropTypes.string,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    pubSubPublish: PropTypes.func.isRequired,
  };

  componentDidMount() {
    focus(this.containerRef);
  }

  saveContainerRef = (ref) => {
    this.containerRef = ref;
  };

  requestLogout = () => {
    const { pubSubPublish, close } = this.props;

    pubSubPublish(EVENTS.SESSION.LOGOUT_USER);
    close();
  };

  isLightbox() {
    const { isLightbox } = getQueryParams(this.props.location.search);
    return isLightbox === 'true';
  }

  requestSubscriptionCancellation = async () => {
    const { channelData, siteUrl, instance, logWidgetSystem } = this.props;
    const { id: channelId } = channelData;

    logWidgetSystem('channel.unsubscribe.requested');
    this.props.cancelOrder(channelId, siteUrl, instance);
  };

  redirectToSubscribe = () => {
    const { match } = this.props;
    this.props.history.push(
      `/payment/${PaymentType.SUBSCRIPTION}/${match.params.channelId}`,
    );
  };

  renderChannelSubscription() {
    const { channelData } = this.props;

    return (
      <AccountSubscription
        className={styles.subscription}
        channelData={channelData}
        onSubscribeClick={this.redirectToSubscribe}
        onSubscriptionCancelClick={this.requestSubscriptionCancellation}
      />
    );
  }

  handleClose = () => {
    this.props.close();
  };

  render() {
    return (
      <section
        ref={this.saveContainerRef}
        role="dialog"
        aria-label={this.props.t('widget.account.modal-title')}
        aria-describedby="account-info"
      >
        <div className={styles.content} id="account-info">
          <AccountInfo
            userEmail={this.props.currentSiteUserEmail}
            logoutLabel={this.props.t('widget.account.logout')}
            onLogoutClick={this.requestLogout}
          >
            {this.renderChannelSubscription()}
          </AccountInfo>
        </div>
        <IconButton
          name="thin-x"
          className={styles.close}
          onClick={this.handleClose}
          ariaLabel={this.props.t('widget.accessibility.close-account-info')}
        />
      </section>
    );
  }
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(ModalAccountInfo)),
);
